import { Popup } from "./popup";

const stockPopup = new Popup(
  "#jsWarehouseWrap",
  "#jsWarehouseOpen",
  "#jsWarehouseClose"
);
stockPopup.init();

window.addEventListener("reset", () => {
  stockPopup.recunstruct(null, "#jsWarehouseOpen", null);
});
